import Head from "next/head";
import React, { ReactElement, useState } from "react";
import { Container } from "react-bootstrap";
import ResetPassword from "../../components/Forms/ResetPassword";
import { ContentLayoutUltraNarrow } from "../../components/_Layout/ContentLayout";
import PageLayout from "../../components/_Layout/PageLayout";

export default function index(): ReactElement {
  const [submited, submitedSet] = useState(false);
  const onSubmit = () => {
    submitedSet(true);
  };
  return (
    <PageLayout>
      <main className="mt-5">
        <Head>
          <title>T-Buddy | Reset password</title>
        </Head>

        <Container>
          <ContentLayoutUltraNarrow className="mx-auto">
            {submited ? (
              <div>
                <h4>Success!</h4>
                <p>Check your mailbox and follow instructions in the letter.</p>
              </div>
            ) : (
              <ResetPassword onSubmit={onSubmit} />
            )}
          </ContentLayoutUltraNarrow>
        </Container>
      </main>
    </PageLayout>
  );
}
